"use client";

export const trackMetaEvent = (eventName: string) => {
  const eventId = crypto.randomUUID();

  // Disparo no Pixel (navegador)
  if (typeof window.fbq === "function") {
    window.fbq("track", eventName, {}, { eventID: eventId });
  }

  // Disparo no servidor (API)
  navigator.sendBeacon(
    "/api/meta-event",
    JSON.stringify({
      event_name: eventName,
      event_id: eventId,
    }),
  );
};
